import { render, staticRenderFns } from "./PropertyEdit.vue?vue&type=template&id=5894523a"
import script from "./PropertyEdit.vue?vue&type=script&lang=js"
export * from "./PropertyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports